<template>
  <div class="row">
    <!-- Total Cost -->
    <div class="col-lg">  
      <tabs type="primary">
        <tab-pane label="Scheduler Time">
          <card type="card-chart">
            <template slot="header">
              <h5 class="card-category">
                
                <tabs type="primary">
                  <tab-pane label="weekdays">
                    <!-- <base-button type="success" round @click="redirect('weekdays')"> Weekdays</base-button> -->
                    <Weekdays2></Weekdays2>
                    
                    <!-- <Weekdays ></Weekdays> -->
                  </tab-pane>
                  <tab-pane label="weekend" >
                    <Weekend2></Weekend2>
                    <!-- <Weekends ></Weekends> -->
                  </tab-pane>

                  <tab-pane label="holidays">
                    <Holidays2></Holidays2>
                    <!-- <Holidays ></Holidays> -->
                  </tab-pane>
                </tabs>
              </h5>
            </template>
          </card>
        </tab-pane>
        <tab-pane label="Set Holidays">
          <card type="chart">
            <template slot="header">
              <h5 class="card-category">
                <tabs type="primary">
                  <tab-pane label="Running Holidays">
                    <RunHolidays></RunHolidays>
                  </tab-pane>
                  <tab-pane label="Manage Holidays">
                    <ManageHolidays></ManageHolidays>
                  </tab-pane>
                </tabs>
              </h5>
            </template>
          </card>
        </tab-pane>
      </tabs>
    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  TimeSelect,
  DatePicker,
  Select,
  Option
} from "element-ui";
import { TabPane, Tabs } from "src/components";
import { Modal, BasePagination } from "src/components";
import Weekdays from "./weekdays";
import Weekends from "./weekend";
import Holidays from "./holiday";
import Weekdays2 from "./weekdays2";
import Weekend2 from "./weekend2";
import Holidays2 from "./holiday2";
import RunHolidays from "./runHolidays";
import ManageHolidays from "./manageHolidays";
import swal from "sweetalert2";
import moment from "moment";
import LineChart from "@/components/Charts/LineChart";
import * as chartConfigs from "@/components/Charts/config";
import config from "@/config";


export default {
  components: {
    TabPane,
    Tabs,
    Modal,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [Option.name]: Option,
    [Select.name]: Select,
    LineChart,
    BasePagination,
    Weekdays,
    Weekends,
    Holidays,
    Weekdays2,
    Weekend2,
    Holidays2,
    RunHolidays,
    ManageHolidays
  },
  data() {
    return {
     
    };
  },
  mounted() {
    
  },
  methods: {
    redirect(a){
     
      if(a == "weekdays"){
        this.$router.push("/weekend");
      }
    }
   
  },
  created() {
    this.cluster = "024eb338-6656-4802-522a-8a1b52d7bcb1"

    let a = "iniate"  
 
    // send flag to initiate graph
    this.$root.$emit("flag", a)
  },
  computed: {
    queriedData() {
      let result = this.holidaysTable;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.holidaysTable.length;
    }
  }
};
</script>

<style scoped>
.analytic el-select {
  display: inline;
}
.a h3 {
  display: inline;
}
</style>
